export const SUPPORTED_WHATS_APP_VARIABLES = [
  "Customer Name",
  "Order Number",
  "Order External Link",
  "Task Name",
  "Due Date",
  "Label",
  "Status",
  "Priority",
];
